import { createApiHandler } from './handler';

const tags = {
  apiClient: null,
  path: '/admin/tags',

  setClient(apiClient) {
    this.apiClient = apiClient;
    this.initApiHandler();
  },

  initApiHandler() {
    Object.assign(this, createApiHandler(this.apiClient, this.path));
  },
};

export default tags;
